export default __webpack_public_path__ + "static/media/loading.7986e9bc.gif";